module.exports = __webpack_public_path__ + "img/arrow.ce19fe92.svg";